import { render, staticRenderFns } from "./editionC11.vue?vue&type=template&id=0fc4d1bc&scoped=true&"
import script from "./editionC11.vue?vue&type=script&lang=js&"
export * from "./editionC11.vue?vue&type=script&lang=js&"
import style0 from "./editionC11.vue?vue&type=style&index=0&id=0fc4d1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4d1bc",
  null
  
)

export default component.exports